export const DataFaci = [
    {
        id: 1,
        image: "/Images/About/Facilities/Delivery Labour Ward.webp",
        title: "Delivery & Caesarean",
        subTitle:"24 Hours",
    },
    {
        id: 2,
        image: "/Images/About/Facilities/Pharamacy.webp",
        title: "Inhouse Pharmacy",
        subTitle:"24 Hours",
    },
    {
        id: 3,
        image: "/Images/About/Facilities/Lab.webp",
        title: "Inhouse Lab",
        subTitle:"24 Hours",
    },
    {
        id: 4,
        image: "/Images/About/Facilities/Reception.webp",
        title: "Reception",
    },
    {
        id: 5,
        image: "/Images/Child/Neonatology/Preterm-Birth-Neonatology-Sivaganaga.webp",
        title: "Ultra Sound and Doppler",
        subTitle:"Monday - Saturday",
    },
    {
        id: 6,
        image: "/Images/Child/Neonatology/Preterm-Birth-Neonatology-Sivaganaga.webp",
        title: "25 Bedded Hospital",
        subTitle:"Emergency and Casualty",
    },
    {
        id: 7,
        image: "/Images/Child/Neonatology/Preterm-Birth-Neonatology-Sivaganaga.webp",
        title: "InPatient",
        subTitle:"24 Hours",
    },
    {
        id: 8,
        image: "/Images/Child/Neonatology/Preterm-Birth-Neonatology-Sivaganaga.webp",
        title: "Newborn Care",
        subTitle:"24 Hours",
    },
    {
        id: 9,
        image: "/Images/Child/Neonatology/Preterm-Birth-Neonatology-Sivaganaga.webp",
        title: "ECHO Services",
        subTitle:"Saturday Morning",
    },
    {
        id: 10,
        image: "/Images/Child/Neonatology/Preterm-Birth-Neonatology-Sivaganaga.webp",
        title: "X-ray Unit",
        subTitle:"24 Hours",
    },
];
